<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <v-col>
                <v-card max-height="400" class="pa-3">
                    <v-card-text>
                        <table style="width:100%; text-align:center">
                            <tr>
                                <td>
                                    <v-btn color="primary" class="ma-2" @click="onClickLogin">再ログイン</v-btn>
                                </td>
                            </tr>
                        </table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            systemState: null
        },
        methods: {
            onClickLogin: function () {
                window.location.reload()
            }
        }
    }
</script>
